import {Building2, FileText, LayoutDashboard, Settings, Shield, UserCog, Users} from "lucide-react";
import {Link, usePage} from "@inertiajs/react";


const AppSidebar = () => {
    const pathname = usePage().url

    const navItems = [
        {
            href: "/dashboard",
            label: "Dashboard",
            icon: LayoutDashboard,
        },
        {
            href: "/tax_payers",
            label: "Taxpayer Management",
            icon: Users,
        },
        {
            href: "/audit",
            label: "Financial Audit",
            icon: FileText,
        },
        {
            href: "/system",
            label: "System Admin",
            icon: Settings,
        },
        {
            href: "/admin/users",
            label: "User Management",
            icon: UserCog,
        },
        {
            href: "/communities",
            label: "Communities",
            icon: Building2,
            superUser: true,
        },
    ]

    return (
        <aside className="w-64 border-r border-border bg-card">
            <div className="flex h-16 items-center border-b border-border px-6">
                <Shield className="mr-2 h-5 w-5 text-primary" />
                <h1 className="text-lg font-semibold text-foreground">Municipal Tax</h1>
            </div>
            <nav className="space-y-1 p-4">
                {navItems.map((item) => {
                    const Icon = item.icon
                    const isActive = pathname === item.href
                    return (
                        <Link
                            key={item.href}
                            href={item.href}
                            className={`flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                                isActive
                                    ? "bg-primary text-primary-foreground"
                                    : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                            } ${item.superUser ? "mt-6 border-t border-border pt-6" : ""}`}
                        >
                            <Icon className="h-4 w-4" />
                            {item.label}
                            {item.superUser && (
                                <span className="ml-auto rounded bg-accent px-1.5 py-0.5 text-xs font-medium text-accent-foreground">
                  Super
                </span>
                            )}
                        </Link>
                    )
                })}
            </nav>
            <div className="absolute bottom-0 w-64 border-t border-border bg-card p-4">
                <div className="flex items-center gap-3">
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-xs font-semibold text-primary-foreground">
                        AD
                    </div>
                    <div className="flex-1">
                        <p className="text-sm font-medium text-foreground">Admin User</p>
                        <p className="text-xs text-muted-foreground">Super Administrator</p>
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default AppSidebar;